// ==================================================================================================
//
// Profile Dropdown Menu Functionality
//
// ==================================================================================================
export const profileMenuDropdown = () => {
  let props = {
    isEnabled : false,
    menuOpened : false
  };
  let els = {};
  // Cache dom element selectors
  // ------------------------------------------------
  const createChildren = () => {
    els.$menuDropdown      = $('.menu-bar__nav--secondary');
    els.$menuDropdownList  = $('.menu-bar__nav--secondary .list-dropdown-menu');
    els.$menuDropdownArrow = $('.menu-bar__nav--secondary .arrow');
  }


  // Add appropriate class to open and close dropdown menu
  // ------------------------------------------------
  const toggleMenuDropdown = (e) => {

    if (props.menuOpened) {
      els.$menuDropdownList.removeClass('menuOpened');
      els.$menuDropdownArrow.removeClass('up');
    } else {
      els.$menuDropdownList.addClass('menuOpened');
      els.$menuDropdownArrow.addClass('up');
    }

    props.menuOpened = !props.menuOpened;
  }

  // Set up for responsive
  // ------------------------------------------------
  const setupResponsive = () => {
    return {
      'sm' : disable,
      'md' : disable,
      'lg' : enable,
      'xl' : enable
    }
  }

  // Enable
  // ------------------------------------------------
  const enable = () => {
    if (props.isEnabled) return;

    // Add your event handlers here
    els.$menuDropdown.on('click', toggleMenuDropdown);

    props.isEnabled = true;

    return;
  }

  // Disable
  // ------------------------------------------------
  const disable = () => {
    if (!props.isEnabled) return;

    els.$menuDropdown.off('click', toggleMenuDropdown);
    els.$menuDropdownList.removeClass('menuOpened');
    els.$menuDropdownArrow.removeClass('up');

    props.isEnabled = false;

    return;
  }

  // Init
  // ------------------------------------------------
  const init = () => {
    createChildren();
    setupResponsive();
    return;
  }

  return {
    init,
    enable,
    disable,
    responsiveCallbacks: setupResponsive()
  };
}

export default profileMenuDropdown;

